import { render, staticRenderFns } from "./card-tertiary.vue?vue&type=template&id=04e85d5a&scoped=true&"
import script from "./card-tertiary.vue?vue&type=script&lang=js&"
export * from "./card-tertiary.vue?vue&type=script&lang=js&"
import style0 from "./card-tertiary.vue?vue&type=style&index=0&id=04e85d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e85d5a",
  null
  
)

export default component.exports